import React, { Component } from 'react'
import { connect } from 'react-redux'
import { beautifyPrice } from 'utils/stuff'

import TextField from 'material-ui/TextField'


let select = (state) => state


export class InputMoney extends Component {
	constructor(props) {
		super(props);
			this.state = {
				value: (this.props.value)?this.props.value:'',

			}
		}
		componentDidMount(){
			if (this.props.value){

				this.setState({value: this.props.value.toString()})

			}
		}
		render() {
			return (
				<div style={{...this.props.style}}>
					{(this.props.disabled)?
						<p className="no-underline" style={{fontSize: "16", fontWeight: "bold", color:"#000000"}}>
							${this.state.value}</p>
						:<TextField
							fullWidth={true}
							hintText={(this.props.hintText)?this.props.hintText:"Enter here"}
							hintStyle={(this.props.hintStyle)?this.props.hintStyle:{fontStyle: "italic", fontSize: "14px"}}
							value={this.state.value}
							inputStyle={(this.props.inputStyle)?this.props.inputStyle:{fontSize: "16px"}}
							disabled={(this.props.disabled)?this.props.disabled:false}
							ref={(this.props.ref)?this.props.ref:''}
							underlineStyle={(this.props.underlineStyle)?this.props.underlineStyle:{borderBottom: "0px solid"}}
							onChange={(evt) => {
								let carret = evt.currentTarget.selectionStart
								let newVal = beautifyPrice(evt.target.value)
								if(this.state.value && evt.target.value.replace(/\D/g, '').length >= this.state.value.replace(/\D/g, '').length){
									if(newVal.length - evt.target.value.length == 1) carret = carret + 1
								}
								this.setState({value: newVal})
							}}
							key={(this.props.key)?this.props.key:''}
							floatingLabelText={(this.props.floatingLabelText)?this.props.floatingLabelText:''}
							onBlur={(evt) => this.props.onBlur(evt.target.value)}
						/>
					}
				</div>
			)
		}
}

export default connect(select)(InputMoney)



// WEBPACK FOOTER //
// ./src/components/InputMoney.js